export const CREATE_REFERRAL_ALIAS_START =
  'CREATE_REFERRAL_ALIAS_START';
export const CREATE_REFERRAL_ALIAS_SUCCESS =
  'CREATE_REFERRAL_ALIAS_SUCCESS';
export const CREATE_REFERRAL_ALIAS_ERROR =
  'CREATE_REFERRAL_ALIAS_ERROR';
